<template>
	<inertia-head title="SMS Messages Management" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">SMS Messages Management</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">SMS Messages</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="text-end mb-4">
			<button @click="viewMesssageModal(0,'add')" class="btn btn-alt-primary">
				<i class="fa fa-plus me-1"></i>
				Add SMS
			</button>
		</div>
		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-title"></div>
				<div class="block-options">
					<div class="input-group">
						<div class="input-group-prepend"><span class="input-group-text">Filter By Subscription</span></div>
						<select v-model="filter" class="form-select">
							<option value="null"></option>
							<option value="ALL">ALL</option>
							<option v-for="(row) in subscriptions" :value="row.subscription">{{row.subscription}}</option>
						</select>
					</div>
				</div>
			</div>
			<div class="block-content block-content-full">
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead>
							<tr>
								<th>DAY NUMBER</th>
								<th>SUBSCRIPTION</th>
								<th>MESSAGE</th>
								<th>ACTIVE</th>
								<th>CREATED</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(message, c_index) in messages.data"
								:key="message.sms_uuid"
							>
								<td>Day {{message.day_num}}</td>
								<td>{{message.subscription}}</td>
								<td>{{message.sms_message_format}}</td>
								<td>{{message.is_active}}</td>
								<td>{{message.date_created}}</td>
								<td class="text-end">
									<button @click="viewMesssageModal(c_index,'update')" type="button" class="btn btn-sm btn-alt-info"><i class="fa fa-pencil-alt"></i></button>
								</td>
							</tr>
							<tr v-if="messages.data.length <= 0">
								<td colspan="6" class="mb-0 fw-semibold text-center p-5">NO SMS MESSAGE FOUND.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="messages.data.length > 0" :collections="messages"/>
			</div>
		</div>
		<add-update-message-content ref="addUpdateMessageModal" :content="selectedMessage" :subscriptions="subscriptions"/>
	</div>
</template>

<script>
import { onMounted, watch, ref, reactive } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'
import AddUpdateMessageContent from '../../Components/Admin/AddUpdateMessageContent'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia';

export default {
	layout: AuthLayout,
	props: {
		messages		: Object,
		subscriptions	: Object,
		filter 			: Object,
		api_response	: Object
	},
	components:{AddUpdateMessageContent},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const filter = ref(props.filter);

		const action = ref('add');

		const toast = createToaster();

		const selectedMessage = reactive({});

		const addUpdateMessageModal = ref(null);

		const viewMesssageModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedMessage.sms_uuid 		= props.messages.data[_index].sms_uuid;
				selectedMessage.day_num 		= props.messages.data[_index].day_num;
				selectedMessage.subscription 	= props.messages.data[_index].subscription;
				selectedMessage.sms_message 	= props.messages.data[_index].sms_message;
				selectedMessage.is_active 		= props.messages.data[_index].is_active;
			}

			addUpdateMessageModal.value.setMessage(_action,selectedMessage);

			addUpdateMessageModal.value.toggleModal();

		}

		watch(filter, (value,old_value) => {
			
			if(value!=old_value)
			{
				var param = {filter:value}

				if(value=="null")
				{
					param = "";
				}

				Inertia.get(
						'/admin/sms-messages', param,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['messages', 'categories','filters']
						}
					)
			}
		})

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action=='add' ? 'added' : 'updated';

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else if(value.result=="exist")
				{
					toast.show(value.data, { type: "error"});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "error"});
				}
			}
		})

		return{
			filter,
			action,
			toast,
			viewMesssageModal,
			selectedMessage,
			addUpdateMessageModal
		}
	},
}
</script>
